export default __webpack_public_path__ + "img/47381c8db7b4332ae8911b883ffbb3bb.svg";